import React, { useEffect, useState } from "react";
import { Gift, X, Sparkles } from "lucide-react";

const CLAIM_URL = "https://ohqak.bemobtrcks.com/click";

const PromoToast = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setModalOpen(true), 3000);
    return () => clearTimeout(t);
  }, []);

  const closeModal = () => {
    setModalOpen(false);
    setTimeout(() => setToastOpen(true), 3000);
  };

  const closeToast = () => setToastOpen(false);

  return (
    <>
      {/* Center welcome modal */}
      {modalOpen && (
        <div
          className="fixed inset-0 z-[70] flex items-center justify-center px-4"
          style={{ background: "rgba(0,0,0,0.7)", backdropFilter: "blur(2px)" }}
          onClick={closeModal}
        >
          <div
            className="cp-slide-in relative w-full max-w-md overflow-hidden rounded-2xl border p-6 text-center sm:p-8"
            style={{
              background: "#121317",
              borderColor: "var(--cp-border)",
              boxShadow: "0 30px 80px rgba(0,0,0,0.7)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* top green bar */}
            <div
              className="absolute inset-x-0 top-0 h-1.5"
              style={{
                background:
                  "linear-gradient(90deg, var(--cp-green), var(--cp-green-hover))",
              }}
            />
            <button
              onClick={closeModal}
              className="absolute right-4 top-4 transition-colors hover:text-white"
              style={{ color: "var(--cp-muted)" }}
              aria-label="Close"
            >
              <X size={18} />
            </button>

            <div
              className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl sm:h-16 sm:w-16"
              style={{ background: "rgba(34,224,107,0.12)", color: "var(--cp-green)" }}
            >
              <Gift size={28} />
            </div>

            <p
              className="mt-4 flex items-center justify-center gap-1.5 text-[11px] font-semibold uppercase tracking-widest sm:mt-5 sm:text-xs"
              style={{ color: "var(--cp-green)" }}
            >
              <Sparkles size={13} />
              New User Welcome Offer
            </p>

            <h2 className="mt-2 text-xl font-bold sm:text-2xl" style={{ color: "#ffffff" }}>
              🎁 Win Up To 150 Free Spins
            </h2>

            <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--cp-muted)" }}>
              Sign up as a new player and claim your exclusive welcome offer — up to{" "}
              <span className="font-semibold" style={{ color: "#ffffff" }}>
                150 free spins
              </span>{" "}
              at a top-rated casino. Quick to claim — no purchase required.
            </p>

            <a
              href={CLAIM_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeModal}
              className="cp-play-btn mt-6 block w-full rounded-lg py-3 text-center text-sm font-bold transition-all"
            >
              Claim Spins
            </a>

            <button
              onClick={closeModal}
              className="mt-3 text-sm transition-colors hover:text-white"
              style={{ color: "var(--cp-muted)" }}
            >
              No thanks, maybe later
            </button>

            <p className="mt-4 text-[11px]" style={{ color: "var(--cp-muted)" }}>
              18+ only. Terms apply. Play responsibly.
            </p>
          </div>
        </div>
      )}

      {/* Bottom-right toast */}
      {toastOpen && (
        <div
          className="cp-slide-in fixed bottom-4 left-4 right-4 z-[60] rounded-2xl border p-4 shadow-2xl sm:left-auto sm:w-[320px] sm:max-w-[calc(100vw-2rem)]"
          style={{
            background: "#121317",
            borderColor: "var(--cp-border)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
          }}
        >
          <button
            onClick={closeToast}
            className="absolute right-3 top-3 transition-colors hover:text-white"
            style={{ color: "var(--cp-muted)" }}
            aria-label="Close"
          >
            <X size={16} />
          </button>

          <div className="flex gap-3">
            <div
              className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg"
              style={{ background: "rgba(34,224,107,0.12)", color: "var(--cp-green)" }}
            >
              <Gift size={18} />
            </div>
            <div className="pr-4">
              <p className="text-sm font-bold" style={{ color: "#ffffff" }}>
                🎁 Win Up To 150 Free Spins
              </p>
              <p className="mt-1 text-xs leading-snug" style={{ color: "var(--cp-muted)" }}>
                Claim your new-user welcome offer — up to 150 free spins. No purchase
                needed.
              </p>
            </div>
          </div>

          <a
            href={CLAIM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cp-play-btn mt-3 block w-full rounded-lg py-2.5 text-center text-sm font-bold transition-all"
          >
            Claim Spins
          </a>
        </div>
      )}
    </>
  );
};

export default PromoToast;
